"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropInfo = void 0;
var DropInfo = /** @class */ (function () {
    function DropInfo(node, rect, location, index, className) {
        this.node = node;
        this.rect = rect;
        this.location = location;
        this.index = index;
        this.className = className;
    }
    return DropInfo;
}());
exports.DropInfo = DropInfo;
//# sourceMappingURL=DropInfo.js.map